<template>
  <v-switch
    color="blue darken-2"
    inset
    v-model="dashboard"
    @change="setFilters()"
    :label="`Use Dashboard Style Home Page`"
  ></v-switch>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "DashboardHomepageToggle",
  data() {
    return {
      dashboard: this.dashboardEnabled,
    };
  },

  computed: {
    dashboardEnabled() {
      if (this.$store.getters.retrieveDashboardHomePage) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    ...mapActions(["setDashboardHomePage"]),

    async setFilters() {
      await this.setDashboardHomePage(this.dashboard);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>